import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../breadcrumb/BreadcrumbOne";
import ProductImageGallery from "../product/ProductImageGallery";

const PortfolioThreeColumn = () => {
    return (
        <>
            <SEO title="Products" />
            <Layout>
                <BreadcrumbOne
                    title="Engineered Power Solutions <br />  Built with Excellence, Trusted Worldwide"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Products"
                />
                <div className="main-content">
                    {/* Start Product Image Gallery Area  */}
                    <ProductImageGallery
                        subtitle="PRODUCT GALLERY"
                        title="Innovative Products, Trusted Performance.!"
                        description="A closer look at the products we manufacture and deliver."
                        sectionClass="rn-section-gap"
                    />
                    {/* End Product Image Gallery Area  */}
                </div>
            </Layout>
        </>
    )
}
export default PortfolioThreeColumn;
